import React from "react";
import Header from "./components/Header";
// import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Sections from "./components/Sections";
import Footer from "./components/Footer";
import { ToastContainer } from "react-toastify"; // ✅ import
import "react-toastify/dist/ReactToastify.css"; // ✅ import CSS
import { Slide } from "react-toastify";
import "./App.css";

function App() {
  return (
    <>
      <Header />
      {/* <Nav /> */}
      <Hero />
      <Sections />
      <Footer />
      <ToastContainer
        position="top-center"
        autoClose={false}
        closeOnClick={false}
        draggable={false}
        closeButton={false}
        newestOnTop
        theme="light"
        transition={Slide}
      />
    </>
  );
}

export default App;
